<template>
  <div>
    <OnboardingIndex
      :title="title"
      :submitButtonText="submitButtonText"
      :verification_running="verification_running"
      @submit="handle_enter_otp"
    >
      <template v-slot:form-content>
        <div class="mb-3">
          <label for="otp_number" class="text-xxs">One Time Pin</label>
          <input
            type="text"
            class="form-control form-control-lg text-xxs bg-light border-0 py-3"
            v-model="otp_number"
            maxlength="5"
            @keypress="validate_numbers"
            placeholder="Enter your One Time Pin here"
          />
        </div>
      </template>

      <!-- Specific to OTP -->
      <template v-slot:signup-content>
        <div class="mt-4 text-center">
          <p class="mb-1">
            Did not receive OTP?
            <a
              :class="{ 'text-muted': otp_sending, 'text-primary': !otp_sending }"
              class="text-decoration-none cursor-pointer"
              @click.prevent="otp_sending ? null : resend_otp()"
            >
              Click here
            </a>
            to resend.
          </p>
        </div>
      </template>
    </OnboardingIndex>
  </div>
</template>
